export enum CustomerZoneEnum {
	FrontScreen = "0A",
	PassengerScreen = "0B",
	LeftScreen = "1A",
	RightScreen = "1B",
	RandomDevice = "Random Device",
}
